const Recharts = window.Recharts;
export const XAxis = Recharts.XAxis;
export const YAxis = Recharts.YAxis;
export const CartesianGrid = Recharts.CartesianGrid;
export const Tooltip = Recharts.Tooltip;
export const Legend = Recharts.Legend;
export const ResponsiveContainer = Recharts.ResponsiveContainer;
export const BarChart = Recharts.BarChart;
export const Bar = Recharts.Bar;
export const Line  = Recharts.Line;
export const ComposedChart = Recharts.ComposedChart;
export const Label = Recharts.Label;




// WEBPACK FOOTER //
// ./src/recharts/index.js